import React from 'react'

import { ClipboardLink } from 'src/chrome'
import { Description, FlexColumn } from 'src/styled'

interface AffiliateLinksProps {
  onCopy: () => void
  slug: string
  domainName: string
  isSoc: boolean
}

const AffiliateLinks: React.FC<AffiliateLinksProps> = props => {
  const { slug, onCopy, domainName, isSoc } = props
  const link = `https://www.${domainName}.com${isSoc ? '/u' : ''}/${slug}`
  return (
    <div style={{ marginTop: 15 }}>
      <p>
        Provide the following URL(s) to someone who is ready to sign up; it
        takes them straight to the ways to get started. Upon enrollment they are
        placed directly in your organization.
      </p>
      <FlexColumn
        style={{
          marginTop: 15,
        }}
      >
        <Description>Directs user to home page</Description>
        <ClipboardLink name={'home'} value={`${link}`} onCopy={onCopy} />
        {isSoc && (
          <>
            <Description>Directs user to catalog</Description>
            <ClipboardLink
              name={'send'}
              value={`${link}/send`}
              onCopy={onCopy}
            />
            <Description>Directs user to business page</Description>
            <ClipboardLink
              name={'business'}
              value={`${link}/business`}
              onCopy={onCopy}
            />
            <Description>Directs user to pricing page</Description>
            <ClipboardLink
              name={'pricing'}
              value={`${link}/pricing`}
              onCopy={onCopy}
            />
          </>
        )}
      </FlexColumn>
    </div>
  )
}

export default AffiliateLinks
